import React from "react";

function Footer(){
    return(
        <div class="text-center p-6 bg-black footer">
        <span class="text-white">&copy; 2022 Copyright - </span>
        <a class="link-underline text-white font-bold" href="https://rahulkarda.netlify.app">Md Saidul Basar Bappy</a>
      </div>
    )
}


export default Footer